var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301.01,
    height: 173,
    viewBox: "0 0 301.01 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(-548.99 -1311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 242,
    height: 173,
    rx: 47,
    transform: "translate(581 1311)",
    fill: "#f5fafd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(609.394 1337.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22267",
    d: "M-166.159,119.276V235.923h10.611v-10.61h10.605V214.707h10.611v-10.6h10.6v-.01h.005V193.513h-.005v-.01h.005v.01h10.61V182.9h-.01V182.9h.01v.005h10.585V172.3c-3.533.005-7.058-.005-10.585-.005V161.687h-10.61V151.081h-10.605V140.471h-10.61V129.866h-10.605v-10.59Z",
    transform: "translate(166.159 -119.276)",
    fill: "#4397d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1-2",
    "data-name": "layer1",
    transform: "translate(612.617 1454.556) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22267-2",
    "data-name": "path22267",
    d: "M0,0V116.647H10.611v-10.61H21.216V95.432H31.826v-10.6h10.6v-.01h.005V74.237h-.005v-.01h.005v.01h10.61V63.627h-.01v-.005h.01v.005H63.627V53.021c-3.533.005-7.058-.005-10.585-.005V42.411H42.432V31.806H31.827V21.195H21.216V10.59H10.611V0Z",
    fill: "#4397d2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 50.716,
    height: 50.716,
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 573.424, 1398.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "photo_1_",
    "data-name": "photo (1)",
    d: "M59.933,6.659A6.679,6.679,0,0,0,53.274,0H6.659A6.679,6.679,0,0,0,0,6.659V53.274a6.679,6.679,0,0,0,6.659,6.659H53.274a6.659,6.659,0,0,0,6.659-6.659ZM43.285,9.989a6.659,6.659,0,1,1-6.659,6.659,6.659,6.659,0,0,1,6.659-6.659ZM6.659,53.274V29.867A17.121,17.121,0,0,1,28.368,31.3L50.81,53.274Z",
    transform: "translate(566.543 1397.319) rotate(-45)",
    fill: "#4397d2",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Aa",
    transform: "translate(745 1422)",
    fill: "#4397d2",
    fontSize: 75,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Aa")), /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_1_",
    "data-name": "right-arrow (1)",
    transform: "translate(691.853 1383.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M122.03,76.367a.767.767,0,0,0-.1-.1L110.939,65.04a.886.886,0,0,0-1.536.591V71.54H95.162c-.532,0-1.123.118-1.123.591v9.455a1.359,1.359,0,0,0,1.123,1.182H109.4v5.318a.945.945,0,0,0,.532.827h.355a.946.946,0,0,0,.65-.3L121.93,77.449A.768.768,0,0,0,122.03,76.367Z",
    transform: "translate(-83.403 -64.756)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M63.58,122.122a.886.886,0,0,0-.886.886v9.455a.886.886,0,0,0,1.773,0v-9.455A.886.886,0,0,0,63.58,122.122Z",
    transform: "translate(-55.603 -115.634)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M32.233,122.122a.886.886,0,0,0-.886.886v9.455a.886.886,0,0,0,1.773,0v-9.455A.886.886,0,0,0,32.233,122.122Z",
    transform: "translate(-27.802 -115.634)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M.886,122.122a.886.886,0,0,0-.886.886v9.455a.886.886,0,0,0,1.773,0v-9.455A.886.886,0,0,0,.886,122.122Z",
    transform: "translate(0 -115.634)",
    fill: "#4397d2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.02d494671dc0045b3e8441bf14561633.svg";
export { ForwardRef as ReactComponent };